<template>
    <ul class="health-check-messages">
        <li>Last 0 - 6 hrs: {{ row.messages_0_to_6_hrs }}</li>
        <li>Last 6 - 12 hrs: {{ row.messages_6_to_12_hrs }}</li>
        <li>Last 12- 24 hrs: {{ row.messages_12_to_24_hrs }}</li>
        <li v-if="!isCollapsed">Last 24 - 48 hrs: {{ row.messages_24_to_48_hrs }}</li>
        <li v-if="!isCollapsed">Last 48 - 72 hrs: {{ row.messages_48_to_72_hrs }}</li>
        <li>
            <a
                href="#"
                @click.prevent="isCollapsed = !isCollapsed"
                >{{ isCollapsed ? 'Show All' : 'Collapse' }}</a
            >
        </li>
    </ul>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],
    data() {
        return {
            isCollapsed: true,
        }
    },
}
</script>
<style lang="scss" scoped>
ul.health-check-messages li {
    margin: 0 !important;
}
</style>
